import { StateStorage } from 'zustand/middleware'
import { createStore } from '../.'

interface UserTokenStore {
  savedTokens: { [key: string]: string[] }
  toggleToken: (walletId: string, tokenId: string) => void
  addToken: (walletId: string, tokenId: string) => void
  isTokenAdded: (walletId: string, tokenId: string) => boolean
}

export const createUserTokensStore = (storage: StateStorage) =>
  createStore<UserTokenStore>(
    storage,
    (set, get) => ({
      savedTokens: {},
      toggleToken(walletId, tokenId) {
        const currentTokens = get().savedTokens
        const existingWalletTokens = currentTokens[walletId] || []

        if (existingWalletTokens.includes(tokenId)) {
          set({
            savedTokens: {
              ...currentTokens,
              [walletId]: currentTokens[walletId].filter((token) => token !== tokenId),
            },
          })
        } else {
          set({
            savedTokens: {
              ...currentTokens,
              [walletId]: [...existingWalletTokens, tokenId],
            },
          })
        }
      },
      addToken(walletId, tokenId) {
        const currentTokens = get().savedTokens
        const existingWalletTokens = currentTokens[walletId] || []

        if (existingWalletTokens.includes(tokenId)) return

        set({
          savedTokens: {
            ...currentTokens,
            [walletId]: [...existingWalletTokens, tokenId],
          },
        })
      },
      isTokenAdded(walletId, tokenId) {
        const currentTokens = get().savedTokens
        const existingWalletTokens = currentTokens[walletId] || []

        return existingWalletTokens.includes(tokenId)
      },
    }),
    {
      persist: {
        name: 'userTokens',
        version: 0,
      },
    }
  )
